var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("route.storedetaillist") } }, [
        _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["IMPORT"] },
                      expression: "{pageName, list: ['IMPORT']}",
                    },
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.downloadExcel(_vm.$t("sfe.route.storedetaillist"))
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.export")))]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{pageName, list: ['LIST']}",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SRStoreList.form.province"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t("common.pleaseSelect"),
                                },
                                on: { change: _vm.provinceChange },
                                model: {
                                  value: _vm.province,
                                  callback: function ($$v) {
                                    _vm.province = $$v
                                  },
                                  expression: "province",
                                },
                              },
                              _vm._l(_vm.regionOptions, function (proviceItem) {
                                return _c("el-option", {
                                  key: proviceItem.value,
                                  attrs: {
                                    label: proviceItem.label,
                                    value: proviceItem.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6, offset: 1 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SRStoreList.form.city") } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t("common.pleaseSelect"),
                                },
                                model: {
                                  value: _vm.city,
                                  callback: function ($$v) {
                                    _vm.city = $$v
                                  },
                                  expression: "city",
                                },
                              },
                              _vm._l(_vm.cityOptions, function (cityItem) {
                                return _c("el-option", {
                                  key: cityItem.value,
                                  attrs: {
                                    label: cityItem.label,
                                    value: cityItem.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{pageName, list: ['LIST']}",
              },
            ],
            attrs: { slot: "footer-right" },
            slot: "footer-right",
          },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.resetData },
              },
              [_vm._v(_vm._s(_vm.$t("common.reset")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "t-search-btn",
                attrs: { size: "small", icon: "el-icon-search" },
                on: { click: _vm.querySearch },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("common.search")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { staticClass: "main-table-container", attrs: { "no-title": true } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "storeCode",
                  label: _vm.$t("sfe.reportModule.storeCode"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  width: "280px",
                  label: _vm.$t("sfe.reportModule.storeName"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: _vm.$t("sfe.reportModule.phone"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tppCount",
                  label: _vm.$t("sfe.reportModule.tppCount"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.paddingNum(scope.row.tppCount))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderQty",
                  label: _vm.$t("sfe.reportModule.ordersTable.orderQuat"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.paddingNum(scope.row.orderQty))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "confirmedQty",
                  label: _vm.$t("sfe.reportModule.ordersTable.confirmQuat"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.paddingNum(scope.row.confirmedQty))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unMonthConfirmedQty",
                  label: _vm.$t("sfe.reportModule.ordersTable.waitConfirmQuat"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.paddingNum(scope.row.unMonthConfirmedQty))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unThreeMonthConfirmedQty",
                  label: _vm.$t(
                    "sfe.reportModule.ordersTable.historyConfirmQuat"
                  ),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.paddingNum(scope.row.unThreeMonthConfirmedQty)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }